// extracted by mini-css-extract-plugin
export default {"vf-badge--tertiary":"BadgeAI_style__vf-badge--tertiary___c2","mini":"BadgeAI_style__mini___e0","vf-badge":"BadgeAI_style__vf-badge___c4","details":"BadgeAI_style__details___f8"};